/* global chisel_ajax */

const $ = window.jQuery;

export default new class {
  constructor() {
    this.selectors = {
      button: '.js-ajax-button',
      form: '.js-ajax-form',
      alert: '.js-ajax-alert',
    };

    this.classes = {
      processing: 'is-processing',
      hidden: 'u-hidden',
      alertError: 'c-alert--error',
      alertSuccess: 'c-alert--success',
    };

    this.$form = $(this.selectors.form);

    this.bindEvent();
    this.appendFormAction();
  }

  appendFormAction() {
    const action = this.$form.data('ajax-action');
    const input = `<input type="hidden" name="action" value="${action}">`;
    this.$form.prepend(input);
  }

  bindEvent() {
    $(this.selectors.button).on('click', event => {
      event.preventDefault();
      this.processForm();
    });
  }

  processForm() {
    const $alert = $(this.selectors.alert);
    if (!this.$form.hasClass(this.classes.processing)) {
      this.$form.addClass(this.classes.processing);
      $alert
        .addClass(this.classes.hidden)
        .removeClass(`${this.classes.alertError} ${this.classes.alertSuccess}`);
      $.ajax({
        method: 'POST',
        dataType: 'json',
        url: chisel_ajax.url,
        data: this.$form.serialize(),
        success: response => {
          if (response.redirect) {
            window.location.href = response.redirect;
          } else {
            if (response.status === 'error') {
              $alert.addClass(this.classes.alertError);
            } else if (response.status === 'success') {
              $alert.addClass(this.classes.alertSuccess);
            }

            $alert.removeClass(this.classes.hidden).html(response.message);
            this.$form.removeClass(this.classes.processing);
          }
        },
      });
    }
  }
}();



// WEBPACK FOOTER //
// ./src/scripts/modules/ajax-user.js